import { useContext, useEffect, useState } from "react";
import INTOUCH_API from "../../services/Api";
import emitter, { QUESTIONARIE_EVENTS } from "../../utils/emitter";
import useCurrentGame from "../../hooks/useCurrentGame";
import Game from "../../store/Game";
import {
  SOCKET_EVENT_TYPES,
  SOCKET_EVENTS,
  SocketContext,
} from "../../components/SocketProvider";

export default function useViewController() {
  const [forms, setForms] = useState(() => []);
  const [formsLoading, setFormLoading] = useState(false);
  const { socket } = useContext(SocketContext);
  const { getCurrentGame } = useCurrentGame();

  const getInsightForms = (silent) => {
    // 17.09: currentGame живёт в localStorage, а бургер пускал сюда по Game.game
    // (MobX) — источники расходятся, и при пустом localStorage страница падала на
    // `currentGame.id` («Cannot read properties of null»). Берём игру из стора как
    // запасной источник, а при её полном отсутствии просто не идём в API.
    const currentGame = getCurrentGame() || Game.game;
    if (!currentGame?.id) {
      setForms([]);
      if (!silent) setFormLoading(false);
      return;
    }
    if (!silent) {
      setFormLoading(true);
    }
    INTOUCH_API.requestManager(
      "getInsightForms",
      { payload: currentGame.id },
      (response) => {
        setForms(response.data);
      },
      () => {},
      () => {
        if (!silent) {
          setFormLoading(false);
        }
      }
    );
  };

  useEffect(() => {
    getInsightForms();
  }, []);

  function onQuestionChanged(response) {
    const { questionId, status, senderId, type } = response;
    if (type === SOCKET_EVENT_TYPES.INSIGHT_FORMS_DATA) {
      setForms(response.data);
    }

    if (type === SOCKET_EVENT_TYPES.STATUS) {
      setForms((prevState) =>
        prevState.map((form) => {
          return form.map((question) =>
            question.questionId === questionId && senderId === question.userId
              ? { ...question, status }
              : question
          );
        })
      );
    }
  }

  function onInsightInvited() {
    getInsightForms(true);
  }

  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.INSIGHT_MESSAGE, onQuestionChanged);
    emitter.on(QUESTIONARIE_EVENTS.INSIGHT_INVITED, onInsightInvited);
    return () => {
      socket.current.off(SOCKET_EVENTS.INSIGHT_MESSAGE, onQuestionChanged);
      emitter.off(QUESTIONARIE_EVENTS.INSIGHT_INVITED, onInsightInvited);
    };
  }, []);

  return {
    forms,
    formsLoading,
  };
}
